import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'

function Ingredients({recipeId}) {

    const [ingredients, setIngredients] = useState([])

    useEffect(() => {

        try {
            const recipeRef = firestore.collection("recipes").doc(recipeId).collection("ingredients");

            recipeRef.onSnapshot(({docs}) => {
                const ingredients = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setIngredients(ingredients)
            })

        } catch (error) {
            
        }

    }, [recipeId])

    return (
        
        <ul>
            {ingredients && ingredients.map((ingredient, index) => {
                return (
                    
                    <li key={index}>{ingredient.amount} {ingredient.amount_unit} {ingredient.ingredient} </li>
                    
                )
            })}
        </ul>
        
    )
}
export default Ingredients